import  Axios  from 'axios';

const root=window.location.hostname.split(".")

export const getAxiosTotall=()=>{
    return Axios.create({
        baseURL:`https://api.delivery.${root[0]==="localhost"?"devbarest":root[1]}.ir/`,
        headers: {
            "x-auth-token": localStorage.getItem("JwtTokens")
        }
    })
}
export const getAxiosNotif=()=>{
    return Axios.create({
        baseURL:"https://api.devbarest.ir/",
        headers: {
            "x-auth-token": localStorage.getItem("JwtTokens")
        }
    })
}